module.exports = __webpack_public_path__ + "12ce8f4f15549514fd0c9dc7669f1b1e.svg";